import { createReducer, on } from '@ngrx/store';
import {
  modifyBuildKit,
  removeBuildKit,
  loadBuildKits,
  loadBuildKitsSuccess,
  loadBuildKitsFailure,
  addBuildKitSuccess,
  addBuildKitFailure,
  modifyBuildKitSuccess,
  modifyBuildKitFailure,
  removeBuildKitSuccess,
  removeBuildKitFailure,
  removeCadModelRevisionQuantity,
  addTraveler,
  removeTraveler,
  addCadModelRevisionQuantity,
  removeCadModelRevisionQuantitySuccess,
  removeCadModelRevisionQuantityFailure,
  addBuildKit,
  loadTravelerCategories,
  loadTravelerCategoriesSuccess,
  loadTravelerCategoriesFailure,
  modifyCadModelRevisionQuantity,
  modifyTraveler,
  addTravelerSuccess,
  addCadModelRevisionQuantitySuccess,
  modifyTravelerSuccess,
  modifyTravelerFailure,
  loadBuildKitsNoInclude,
  loadCadModels,
  loadCadModelsSuccess,
  loadCadModelsFailure,
  modifyBuildKitSettings,
  loadArchivedBuildKits,
  loadArchivedBuildKitsSuccess,
  loadArchivedBuildKitsFailure,
  archiveBuildKit,
  archiveBuildKitSuccess,
  archiveBuildKitFailure,
  unArchiveBuildKit,
  unArchiveBuildKitSuccess,
  unArchiveBuildKitFailure,
  clearSelectedBuildKit,
  setSelectedBuildKitFromRoute, setSelectedBuildKitFromTree,
  updateBuildKitFlags,
} from "./build-kit.action";
import {
  BuildKit,
  CadModelRevisionQuantity,
  Traveler,
  TravelerCategory
} from "../../../shared/models/build-kit.model";
import {StateStatus} from "../../../shared/models/state-status.models";

import {CadModel} from "../../../shared/models/cad-model.model";
export interface BuildKitState {
  buildKits: BuildKit[];
  selectedBuildKitId: string |  null,
  cadModels: CadModel[];
  travelerCategories: TravelerCategory[];
  error: string | null;
  buildKitStatus: StateStatus;
  travelerStatus: StateStatus;
  revisionQuantityStatus: StateStatus;
  travelerCategoryStatus: StateStatus;
  cadModelStatus: StateStatus;
  archivedBuildKits: BuildKit[];
  archivedBuildKitsStatus: StateStatus;
}

export const initialState: BuildKitState = {
  buildKits: [],
  archivedBuildKits: [],
  cadModels: [],
  selectedBuildKitId: null,
  travelerCategories: [],
  error: null,
  buildKitStatus: 'pending' as StateStatus,
  travelerStatus: 'pending' as StateStatus,
  revisionQuantityStatus: 'pending' as StateStatus,
  travelerCategoryStatus: 'pending' as StateStatus,
  cadModelStatus: 'pending' as StateStatus,
  archivedBuildKitsStatus: 'pending' as StateStatus
};

export const buildKitReducer = createReducer(
  initialState,
  on(setSelectedBuildKitFromRoute, setSelectedBuildKitFromTree, (state, { selectedBuildKitId }): BuildKitState => ({
    ...state,
    selectedBuildKitId: selectedBuildKitId,
  })),
  on(clearSelectedBuildKit, (state): BuildKitState => ({
    ...state,
    selectedBuildKitId: null,
  })),
  on(addCadModelRevisionQuantity, (state) => ({
    ...state,
    revisionQuantityStatus: 'adding' as StateStatus,
  })),
  on(removeCadModelRevisionQuantity, (state, { cadModelRevisionQuantity }) => ({
    ...state,
    revisionQuantityStatus: 'removing' as StateStatus,
    buildKits: state.buildKits.map(originalBuildKit => {
      return originalBuildKit.id === cadModelRevisionQuantity.buildKitId ? {
          ...originalBuildKit,
          cadModelRevisionQuantities: originalBuildKit.cadModelRevisionQuantities.filter((cadModelQuantity: CadModelRevisionQuantity) => cadModelQuantity.id !== cadModelRevisionQuantity.id )
        }
        : originalBuildKit;
    })
  })),
  on(removeCadModelRevisionQuantitySuccess, (state) => ({
    ...state,
    revisionQuantityStatus: 'removeSuccess' as StateStatus,
  })),
  on(removeCadModelRevisionQuantityFailure, (state, { error }) => ({
    ...state,
    revisionQuantityStatus: 'removeError' as StateStatus,
    error: error,
  })),
  on(addTraveler, (state) => ({
    ...state,
    travelerStatus: 'adding' as StateStatus,
  })),
  on(addTravelerSuccess, (state, { traveler }) => ({
    ...state,
    travelerStatus: 'addSuccess' as StateStatus,
    buildKits: state.buildKits.map((originalBuildKit: BuildKit) => {
      if (originalBuildKit.id === traveler.buildKitId){
        return {
          ...originalBuildKit,
          travelers: [
            traveler,
            ...originalBuildKit.travelers,
          ]
        }
      }
      return originalBuildKit;
    })
  })),
  on(addCadModelRevisionQuantitySuccess, (state, { cadModelRevisionQuantity }) => ({
    ...state,
    revisionQuantityStatus: 'addSuccess' as StateStatus,
    buildKits: state.buildKits.map((originalBuildKit: BuildKit) => {
      if (originalBuildKit.id === cadModelRevisionQuantity.buildKitId){
        const newCadModelRevisionQuantity = {
          ...cadModelRevisionQuantity,
          cadModelId: cadModelRevisionQuantity.cadModelRevision.cadModelId
        } as CadModelRevisionQuantity;
        return {
          ...originalBuildKit,
          cadModelRevisionQuantities: [
            newCadModelRevisionQuantity,
            ...originalBuildKit.cadModelRevisionQuantities,
          ]
        }
      }
      return originalBuildKit;
    })
  })),
  on(removeTraveler, (state, { traveler }) => ({
    ...state,
    travelerStatus: 'removing' as StateStatus,
    buildKits: state.buildKits.map(originalBuildKit => {
      return originalBuildKit.id === traveler.buildKitId ? {
        ...originalBuildKit,
        travelers: originalBuildKit.travelers.filter((originalTraveler: Traveler) => originalTraveler.id !== traveler.id )
        }
        : originalBuildKit;
    })
  })),
  on(modifyBuildKit, (state, { buildKit }) => ({
    ...state,
    buildKitStatus: 'modifying' as StateStatus,
    buildKits: state.buildKits.map(originalBuildKit => {
      return originalBuildKit.id === buildKit.id ? {
        ...originalBuildKit,
        name: buildKit.name,
        no: buildKit.no,
        description: buildKit.description,
        comments: buildKit.comments
      }
      : originalBuildKit;
    })
  })),
  on(modifyCadModelRevisionQuantity, (state, { cadModelRevisionQuantity }) => ({
    ...state,
    revisionQuantityStatus: 'modifying' as StateStatus,
    buildKits: state.buildKits.map(originalBuildKit => {
      return originalBuildKit.id === cadModelRevisionQuantity.buildKitId ? {
          ...originalBuildKit,
          cadModelRevisionQuantities: originalBuildKit.cadModelRevisionQuantities.map((x: CadModelRevisionQuantity) => {
              return x.id === cadModelRevisionQuantity.id ? cadModelRevisionQuantity : x
            }
          )
        }
        : originalBuildKit;
    })
  })),
  on(modifyTraveler, (state, { traveler }) => ({
    ...state,
    travelerStatus: 'modifying' as StateStatus,
    buildKits: state.buildKits.map(originalBuildKit => {
      return originalBuildKit.id === traveler.buildKitId ? {
          ...originalBuildKit,
          travelers: originalBuildKit.travelers.map((x: Traveler) => x.id == traveler.id ? traveler : x)
        }
        : originalBuildKit;
    }),
  })),
  on(removeBuildKit, (state, { buildKitId }) => ({
    ...state,
    buildKitStatus: 'removing' as StateStatus
  })),
  on(loadBuildKits, (state) => ({ ...state, buildKitStatus: 'loading' as StateStatus })),
  on(loadBuildKitsNoInclude, (state) => ({ ...state, buildKitStatus: 'loading' as StateStatus })),
  on(loadBuildKitsSuccess, (state, { buildKits }) => ({
    ...state,
    buildKits: buildKits,
    error: null,
    buildKitStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadBuildKitsFailure, (state, { error }) => ({
    ...state,
    error: error,
    buildKitStatus: 'error' as StateStatus,
  })),
  on(addBuildKit, (state, { buildKit }) => ({
    ...state,
    buildKitStatus: 'adding' as StateStatus,
  })),
  on(addBuildKitSuccess, (state, { buildKit }) => ({
    ...state,
    buildKitStatus: 'addSuccess' as StateStatus,
    buildKits: [
      buildKit,
      ...state.buildKits
    ],
    selectedBuildKitId: buildKit.id,
    selectedBuildKitSettings: buildKit?.settings ?? null,
  })),
  on(addBuildKitFailure, (state, { error }) => ({
    ...state,
    buildKits: state.buildKits,
    error: error,
    buildKitStatus: 'error' as StateStatus,
  })),
  on(modifyBuildKitSuccess, (state, {buildKit}) => ({
    ...state,
    error: null,
    buildKitStatus: 'saveSuccess' as StateStatus,
  })),
  on(modifyBuildKitFailure, (state, { error }) => ({
    ...state,
    buildKits: state.buildKits,
    error: error,
    buildKitStatus: 'error' as StateStatus,
  })),

  on(modifyTravelerSuccess, (state, {traveler}) => ({
    ...state,
    error: null,
    travelerStatus: 'modifySuccess' as StateStatus,
  })),
  on(modifyTravelerFailure, (state, { error, traveler }) => ({
    ...state,
    buildKits: state.buildKits,
    error: error,
    travelerStatus: 'modifyError' as StateStatus,
  })),

  on(removeBuildKitSuccess, (state, { buildKitId }) => ({
    ...state,
    buildKits: state.buildKits.filter((buildKit) => buildKit.id !== buildKitId),
    selectedBuildKitId: null,
    selectedBuildKitSettings: null,
    error: null,
    buildKitStatus: 'removeSuccess' as StateStatus,
  })),
  on(removeBuildKitFailure, (state, { error }) => ({
    ...state,
    error: error,
    buildKitStatus: 'error' as StateStatus,
  })),

  on(loadTravelerCategories, (state) => ({ ...state, travelerCategoryStatus: 'loading' as StateStatus })),
  on(loadTravelerCategoriesSuccess, (state,  { travelerCategories }) => ({
    ...state,
    travelerCategories: travelerCategories,
    error: null,
    travelerCategoryStatus: 'saveSuccess' as StateStatus,
  })),
  on(loadTravelerCategoriesFailure, (state, { error }): BuildKitState => ({
    ...state,
    error: error,
    travelerCategoryStatus: 'error' as StateStatus,
  })),
  on(loadCadModels, (state): BuildKitState => ({ ...state, cadModelStatus: 'loading' as StateStatus })),
  on(loadCadModelsSuccess, (state, { cadModels }): BuildKitState => ({
    ...state,
    cadModels: cadModels,
    error: null,
    cadModelStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadCadModelsFailure, (state, { error }): BuildKitState => ({
    ...state,
    error: error,
    cadModelStatus: 'error' as StateStatus,
  })),
  on(modifyBuildKitSettings, (state, { buildKitSettings, buildKitId }) => ({
    ...state,
    buildKits: state.buildKits.map(originalBuildKit => {
      return originalBuildKit.id === buildKitId ? {
          ...originalBuildKit,
          settings: buildKitSettings
        }
        : originalBuildKit;
    }),
    selectedBuildKitId: buildKitId,
    selectedBuildKitSettings: buildKitSettings
  })),
  on(loadArchivedBuildKits, (state) => ({
    ...state,
    archivedBuildKitsStatus: 'loading' as StateStatus,
  })),
  on(loadArchivedBuildKitsSuccess, (state, { archivedBuildKits }): BuildKitState => ({
    ...state,
    archivedBuildKits,
    archivedBuildKitsStatus: 'success' as StateStatus,
    error: null
  })),
  on(loadArchivedBuildKitsFailure, (state, { error }) => ({
    ...state,
    archivedBuildKitsStatus: 'error' as StateStatus,
    error
  })),
  on(archiveBuildKit, (state, { buildKitId }) => ({
    ...state,
    buildKitStatus: 'archiving' as StateStatus,
  })),
  on(archiveBuildKitSuccess, (state, { buildKitId }) => ({
    ...state,
    archivedBuildKits: [...state.archivedBuildKits, {...state.buildKits.find(bk => bk.id == buildKitId) as BuildKit, archived: true}],
    buildKits: state.buildKits.filter((buildKit) => {
      return buildKit.id != buildKitId
    }),
    selectedBuildKitId: buildKitId.toString(),
    error: null,
    buildKitStatus: 'archiveSuccess' as StateStatus,
  })),
  on(archiveBuildKitFailure, (state, { error }) => ({
    ...state,
    error: error,
    buildKitStatus: 'archiveError' as StateStatus,
  })),

  on(unArchiveBuildKit, (state, { buildKitId }): BuildKitState => ({
    ...state,
    buildKitStatus: 'unArchiving' as StateStatus,
  })),
  on(unArchiveBuildKitSuccess, (state, { buildKitId }): BuildKitState => ({
    ...state,
    buildKits: [...state.buildKits, {...state.archivedBuildKits.find(bk => bk.id == buildKitId) as BuildKit, archived: false}],
    archivedBuildKits: state.archivedBuildKits.filter((buildKit) => {
      return buildKit.id != buildKitId
    }),
    selectedBuildKitId: buildKitId.toString(),
    error: null,
    archivedBuildKitsStatus: 'unArchiveSuccess' as StateStatus,
  })),
  on(unArchiveBuildKitFailure, (state, { error }): BuildKitState => ({
    ...state,
    error: error,
    archivedBuildKitsStatus: 'unArchiveError' as StateStatus,
  })),
  on(updateBuildKitFlags, (state, { buildKitId, isRedline, isNonConformance }): BuildKitState => ({
    ...state,
    buildKits: state.buildKits.map(bk => bk.id === buildKitId ? { ...bk, isRedline, isNonConformance } : bk),
    archivedBuildKits: state.archivedBuildKits.map(bk => bk.id === buildKitId ? { ...bk, isRedline, isNonConformance } : bk),
  })),
);
